import { link } from "fs";
import TomSelect from "tom-select";
import "./role_requirements_popup";
import "./language_criteria_popup";

function camelCaseToWords(s) {
	const result = s.replace(/([A-Z])/g, " $1").toLowerCase();
	return result.charAt(0).toUpperCase() + result.slice(1);
}

function parseExistingData(json) {
	const data = JSON.parse(json);

	if (data.version == 2) {
		if (!data.skills) {
			data.skills = [];
		}

		return data;
	}

	const transformKeys = ["job_titles", "locations", "schools", "companies"];

	const oldLocationFilterNames = {
		current: "currentLocation",
		currentOrOpenToRelocate: "preferredOrCurrent",
		openToRelocateOnly: "preferredNotCurrent",
	};

	const transform = (obj) =>
		obj.items.map((item) => ({
			text: item,
			filter: obj.filter,
		}));

	const result = Object.keys(data).reduce((acc, key) => {
		if (transformKeys.includes(key) && !Array.isArray(data[key])) {
			acc[key] = transform(data[key]);

			if (key === "locations") {
				acc[key] = acc[key].map((location) => ({
					...location,
					filter: oldLocationFilterNames[location.filter] || location.filter,
				}));
			}
		} else {
			acc[key] = data[key];
		}
		return acc;
	}, {});

	if (!result.skills) {
		result.skills = [];
	}

	return result;
}

export function initSearchPreviews() {
	const searchPreviewId = $("#search_preview_id").val();
	const existingData = $("#search_preview_data").val();
	const existingAiReviewFilters = $("#ai_review_filters").val();

	let data = existingData
		? parseExistingData(existingData)
		: {
			job_titles: [],
			locations: [],
			companies: [],
			schools: [],
			skills: [],
			years_of_experience: { min: null, max: null },
			years_of_graduation: { min: null, max: null },
			keywords: "",
		};

	window.aiReviewFilters = existingAiReviewFilters
		? JSON.parse(existingAiReviewFilters)
		: {
			role_requirements: [],
			language_criteria: [],
			remove_freelancers: false,
      additional_criteria: "",
		};

	if (!window.aiReviewFilters.role_requirements) window.aiReviewFilters.role_requirements = [];
	if (!window.aiReviewFilters.language_criteria) window.aiReviewFilters.language_criteria = [];
	if (window.aiReviewFilters.remove_freelancers === undefined) window.aiReviewFilters.remove_freelancers = false;
  if (!window.aiReviewFilters.additional_criteria) window.aiReviewFilters.additional_criteria = "";

	const aiReviewFilters = window.aiReviewFilters;

	const renderAddedItems = () => {
		$(".added-items").empty();

		data.job_titles.forEach(function (jobTitle, index) {
			const element = $("<div class='added-item'>")
				.html(`<b class='mr-1'>${jobTitle.text}</b>(${camelCaseToWords(jobTitle.filter)})`)
				.attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				data.job_titles.splice(indexToRemove, 1);
				renderAddedItems();
			});

			$(".job-titles .added-items").append(element);
			$("input#job-title").val("");
		});

		data.locations.forEach(function (location, index) {
			const filterNames = {
				currentLocation: "Current",
				preferredNotCurrent: "Open to relocate only",
				preferredOrCurrent: "Current or open to relocate",
			};
			const element = $("<div class='added-item'>")
				.html(`<b class='mr-1'>${location.text}</b>(${filterNames[location.filter]})`)
				.attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				const locationToRemove = data.locations[indexToRemove];

				data.locations.splice(indexToRemove, 1);

				if ($("#location-input")[0] && $("#location-input")[0].tomselect) {
					const tomselect = $("#location-input")[0].tomselect;

					let valueToRemove = null;
					for (const [value, option] of Object.entries(tomselect.options)) {
						if (option.text === locationToRemove.text || value === locationToRemove.text) {
							valueToRemove = value;
							break;
						}
					}

					if (valueToRemove && tomselect.items.includes(valueToRemove)) {
						tomselect.removeItem(valueToRemove, true);
					}

					tomselect.clearCache();
					tomselect.clearOptions();
					tomselect.loadedSearches = {};
				}

				renderAddedItems();
			});

			$(".locations .added-items").append(element);
		});

		data.companies.forEach(function (company, index) {
			const canHaveText = {
				canHave: "Can have",
				mustHave: "Must have",
				doesNotHave: "Doesn't have"
			};

			const element = $("<div class='added-item'>")
				.html(`<b class='mr-1'>${company.text}</b>(${camelCaseToWords(company.filter)} - ${canHaveText[company.canHave || 'canHave']})`)
				.attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				const companyToRemove = data.companies[indexToRemove];

				data.companies.splice(indexToRemove, 1);

				if ($("#company-input")[0] && $("#company-input")[0].tomselect) {
					const tomselect = $("#company-input")[0].tomselect;

					let linkedinIdToRemove = null;
					for (const [id, option] of Object.entries(tomselect.options)) {
						if (option.text === companyToRemove.text) {
							linkedinIdToRemove = id;
							break;
						}
					}

					if (linkedinIdToRemove && tomselect.items.includes(linkedinIdToRemove)) {
						tomselect.removeItem(linkedinIdToRemove, true);
					}

					tomselect.clearCache();
					tomselect.clearOptions();
					tomselect.loadedSearches = {};
				}

				renderAddedItems();
			});

			$(".companies .added-items").append(element);
		});

		data.schools.forEach(function (text, index) {
			const element = $("<div class='added-item'>").text(text).attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				data.schools.splice(indexToRemove, 1);
				renderAddedItems();
			});

			$(".schools .added-items").append(element);
		});

		const skills = data.skills || [];

		skills.forEach(function (text, index) {
			const element = $("<div class='added-item'>").text(text).attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				const skillToRemove = data.skills[indexToRemove];

				data.skills.splice(indexToRemove, 1);

				if ($("#skill-input")[0] && $("#skill-input")[0].tomselect) {
					const tomselect = $("#skill-input")[0].tomselect;

					let linkedinIdToRemove = null;
					for (const [id, option] of Object.entries(tomselect.options)) {
						if (option.text === skillToRemove) {
							linkedinIdToRemove = id;
							break;
						}
					}

					if (linkedinIdToRemove && tomselect.items.includes(linkedinIdToRemove)) {
						tomselect.removeItem(linkedinIdToRemove, true);
					}

					tomselect.clearCache();
					tomselect.clearOptions();
					tomselect.loadedSearches = {};
				}

				renderAddedItems();
			});

			$(".skills .added-items").append(element);
		});

		if (data.keywords.length) {
			const element = $("<div class='added-item'>").text(data.keywords);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-edit'></i>");
			element.append(close);

			element.click(function () {
				$("#add-keywords .add-input").show();
				$(".keywords .added-items").empty();
				$("#add-keywords textarea").focus();
			});

			$(".keywords .added-items").append(element);
		}

		if (data.years_of_experience.min && data.years_of_experience.max) {
			const from = data.years_of_experience.min;
			let to = data.years_of_experience.max;
			const element = $("<div class='added-item'>").text(`${from} - ${to}`);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				data.years_of_experience = { min: null, max: null };
				$(".years-of-experience .added-items").empty();
				$("#add-years-of-experience .add-button").show();
			});

			$(".years-of-experience .added-items").append(element);
		}

		if (data.years_of_graduation.min && data.years_of_graduation.max) {
			const from = data.years_of_graduation.min;
			let to = data.years_of_graduation.max;
			const element = $("<div class='added-item'>").text(`${from} - ${to}`);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				data.years_of_graduation = { min: null, max: null };
				$(".years-of-graduation .added-items").empty();
				$("#add-years-of-graduation .add-button").show();
			});

			$(".years-of-graduation .added-items").append(element);
		}

		aiReviewFilters.role_requirements.forEach(function (requirement, index) {
      const type = requirement.type;
      const display = requirement.display;
      const mapping = {
        'software' : 'Software Engineering',
        'data' : 'Data & Analytics',
        'other' : 'Other' 
      }
			const displayText = [mapping[type], display].join(" - ") || "Unknown Role";
			const element = $("<div class='added-item'>").text(displayText).attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				aiReviewFilters.role_requirements.splice(indexToRemove, 1);
				renderAddedItems();
			});

			$(".role-requirements .added-items").append(element);
		});

		aiReviewFilters.language_criteria.forEach(function (requirement, index) {
			const displayText = requirement.display || "Unknown Language";
			const element = $("<div class='added-item'>").text(displayText).attr("data-index", index);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				const indexToRemove = $(this).data("index");
				aiReviewFilters.language_criteria.splice(indexToRemove, 1);
				renderAddedItems();
			});

			$(".language-criteria .added-items").append(element);
		});

		if (aiReviewFilters.remove_freelancers) {
			const element = $("<div class='added-item'>").text("Freelancers Removed");
			const close = $("<div>").addClass("close-button").html("<i class='far fa-minus-circle'></i>");
			element.append(close);

			element.click(function () {
				aiReviewFilters.remove_freelancers = false;
				renderAddedItems();
			});

			$(".freelancer-filter .added-items").append(element);
		}

    if (aiReviewFilters.additional_criteria.length) {
			const element = $("<div class='added-item'>").text(aiReviewFilters.additional_criteria);
			const close = $("<div>").addClass("close-button").html("<i class='far fa-edit'></i>");
			element.append(close);

			element.click(function () {
				$("#additional-criteria .add-input").show();
				$(".additional-criteria .added-items").empty();
				$("#additional-criteria textarea").focus();
			});

			$(".additional-criteria .added-items").append(element);
		}

		// $("#add-role-requirements .add-button").show();
		// $("#add-language-criteria .add-button").show();
		// $("#add-freelancer-filter .add-button").show();
	};

	window.renderAddedItems = renderAddedItems;
  if (existingData) {
    renderAddedItems();
  }

	// $("#add-role-requirements .add-input").hide();
	// $("#add-language-criteria .add-input").hide();
	// $("#add-role-requirements .add-button").show();
	// $("#add-language-criteria .add-button").show();
	// $("#add-freelancer-filter .add-button").show();

	// Location input - plain text, add on Enter
	$("#location-input").on("keypress", function (e) {
		if (e.which === 13) {
			e.preventDefault();
			const text = $(this).val().trim();
			if (!text) return;

			const filter = $('input[name="location-status"]:checked').val();

			if (data.locations.some(l => l.text === text)) return;

			data.locations = [...data.locations, { text: text, filter: filter }];
			renderAddedItems();
			$(this).val("");
		}
	});

	// Initialize TomSelect for Skills
	if ($("#skill-input").length) {
		new TomSelect("#skill-input", {
			valueField: 'id',
			labelField: 'text',
			searchField: 'text',
			maxItems: null,
			cache: false,
			create: false,
			hideSelected: true,
			render: {
				item: function () {
					const el = document.createElement('div');
					el.className = 'd-none';
					return el;
				}
			},
			load: function (query, callback) {
				const searchParams = new URLSearchParams({ q: query });
				data.skills.forEach(s => searchParams.append("except[]", s));

				var url = '/suggestions/skills?' + searchParams.toString();

				fetch(url)
					.then(response => response.json())
					.then(json => {
						callback(
							json.map(skill => ({
								id: skill.linkedin_id,
								text: skill.text
							}))
						);
					})
					.catch(() => callback());
			},
			onItemAdd: function (id) {
				const option = this.options[id];
				if (!option) return;

				const keyword = option.text;
				if (data.skills.includes(keyword)) return;

				data.skills = [...data.skills, keyword];
				renderAddedItems();

				this.focus();
			},
			onType: function () {
				this.loadedSearches = {};
				this.clearOptions();
			},
		});
	}

	// Initialize TomSelect for Companies
	if ($("#company-input").length) {
		new TomSelect("#company-input", {
			valueField: 'id',
			labelField: 'text',
			searchField: 'text',
			maxItems: null,
			cache: false,
			create: false,
			hideSelected: true,
			render: {
				item: function () {
					const el = document.createElement('div');
					el.className = 'd-none';
					return el;
				}
			},
			load: function (query, callback) {
				this.loadedSearches = {};
				fetch('/suggestions/companies?q=' + encodeURIComponent(query))
					.then(res => res.json())
					.then(json => {
						callback(
							json.map(company => ({
								id: company.linkedin_id,
								text: company.text
							}))
						);
					})
					.catch(() => callback());
			},
			onItemAdd: function (id) {
				const option = this.options[id];
				if (!option) return;

				const filter = $('input[name="company-status"]:checked').val();
				const canHave = $('input[name="company-can-have"]:checked').val();

				if (data.companies.length >= 20) {
					alert("Maximum 20 companies");
					return;
				}

				if (data.companies.some(c => c.text === option.text)) { return; }

				data.companies = [
					...data.companies,
					{
						text: option.text,
						filter: filter,
						canHave: canHave,
						linkedin_id: id
					}
				];

				renderAddedItems();
				this.focus();
			},
			onType: function () {
				this.loadedSearches = {};
				this.clearOptions();
			}
		});
	}

	$(document).ready(function () {
		$(".search-button").click(function () {
			var targetingId = $("#targeting_id").val();
			var url = `/targetings/${targetingId}/search_previews`;

			if (searchPreviewId) {
				url = `/targetings/${targetingId}/search_previews/${searchPreviewId}`;
			}

			$.ajax({
				url,
				type: searchPreviewId ? "PATCH" : "POST",
				contentType: "application/json",
				data: JSON.stringify({
					data: data,
					role_requirements: aiReviewFilters.role_requirements,
					language_criteria: aiReviewFilters.language_criteria,
					remove_freelancers: aiReviewFilters.remove_freelancers,
          additional_criteria: aiReviewFilters.additional_criteria
				}),
				success: function (response) {
					if (response.errors) {
						alert(response.errors.join("\n"));
					} else if (response.id) {
						window.location.href = `/targetings/${targetingId}/search_previews/${response.id}`;
					}
				},
				error: function (error) {
					const response = JSON.parse(error.responseText);

					if (response.redirect_url) {
						if (confirm(response.errors[0])) {
							window.open(response.redirect_url, "_blank");
						}
					}
				},
			});
		});

		// Generic click handler for add buttons (excluding AI Review filters which have their own handlers)
		$(".add-container .add-button").not("#add-role-requirements .add-button, #add-language-criteria .add-button, #add-freelancer-filter .add-button").click(function () {
      const container = $(this).parent();
			$(this).hide();
			const input = $(container).find(".add-input");
			input.show();

			$(document).mousedown(function (e) {
				if (
					[
						"add-keywords",
						"add-years-of-experience",
						"add-years-of-graduation",
            "additional-criteria",
					].includes(container.attr("id"))
				) {
					return;
				}

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$(this).show();
					$(container).find(".add-input").hide();
					$(container).find(".add-button").show();
				}
			});
		});

		const saveYearsOfExperience = () => {
			var min = $("#min-years-of-experience").val() || 0;
			var max = $("#max-years-of-experience").val() || 30;
			data.years_of_experience.min = min;
			data.years_of_experience.max = max;
			$("#add-years-of-experience .add-input").hide();
		};

		const saveYearsOfGraduation = () => {
			var min = $("#min-years-of-graduation").val() || 0;
			var max = $("#max-years-of-graduation").val() || 30;
			data.years_of_graduation.min = min;
			data.years_of_graduation.max = max;
			$("#add-years-of-graduation .add-input").hide();
		};

		$(".add-input input").on("keypress", function (e) {
			const id = $(this).closest(".add-container").attr("id");
			const textElem = $(this)
				.closest(".add-container")
				.find(".add-input input[type='text']");

			if (e.which == 13) {
				e.preventDefault();

				if (id === "add-job-titles") {
					var text = $(textElem).val();
					var filter = $('input[name="job-status"]:checked').val();

					if (!data.job_titles.some(j => j.text === text)) {
						data.job_titles = [...data.job_titles, { text, filter }];
					}
				} else if (id === "add-schools") {
					var text = $(textElem).val();
					if (!data.schools.includes(text)) {
						data.schools = [...data.schools, text];
					}
				} else if (id === "add-years-of-experience") {
					saveYearsOfExperience();
				} else if (id === "add-years-of-graduation") {
					saveYearsOfGraduation();
				} else if (id === "add-locations") {
					// Handled by #location-input keypress handler
					return;
				} else {
					alert("Not implemented yet");
				}

				renderAddedItems();

				if (
					id !== "add-years-of-experience" &&
					id !== "add-years-of-graduation"
				) {
					$(textElem).val("");
				}
			}
		});

		$("#add-years-of-experience .save-button").click(function () {
			saveYearsOfExperience();
			renderAddedItems();
		});

		$("#add-years-of-graduation .save-button").click(function () {
			saveYearsOfGraduation();
			renderAddedItems();
		});

		$(".add-input textarea.keywords-textarea").on("keypress", function (e) {
			if (e.which == 13) {
				e.preventDefault();
				submitKeywords($(this));
			}
		});

    $(".add-input textarea.criteria-textarea").on("keypress", function (e) {
			if (e.which == 13) {
				e.preventDefault();
				submitCriteria($(this));
			}
		});

		$("#submit-keywords").click(function () {
			submitKeywords($("#add-keywords textarea"));
		});

		$("#remove-keywords").click(function () {
			data.keywords = "";
			$("#add-keywords textarea").val("");
			renderAddedItems();
			$("#add-keywords .add-input").hide();
			$("#add-keywords .add-button").show();
		});

		function submitKeywords(textareaElement) {
			const container = textareaElement.closest(".add-container");
			const text = textareaElement.val();
			data.keywords = text;

			$(container).find(".add-input").hide();

			if (text.length) {
				$(container).find(".add-button").hide();
			} else {
				$(container).find(".add-button").show();
			}

			renderAddedItems();
			textareaElement.blur();
		}

		$("#add-freelancer-filter .add-button").click(function() {
			aiReviewFilters.remove_freelancers = true;
			renderAddedItems();
		});

    $("#submit-criteria").click(function () {
			submitCriteria($("#additional-criteria textarea"));
		});

		$("#remove-criteria").click(function () {
			aiReviewFilters.additional_criteria = "";
			$("#additional-criteria textarea").val("");
			renderAddedItems();
			$("#additional-criteria .add-input").hide();
			$("#additional-criteria .add-button").show();
		});

    function submitCriteria(textareaElement) {
			const container = textareaElement.closest(".add-container");
			const criteria = textareaElement.val();
			aiReviewFilters.additional_criteria = criteria;

			$(container).find(".add-input").hide();

			if (criteria.length) {
				$(container).find(".add-button").hide();
			} else {
				$(container).find(".add-button").show();
			}

			renderAddedItems();
			textareaElement.blur();
		}
	});
}
